import React from 'react';
import { motion } from 'framer-motion';
import { FaReact, FaNodeJs, FaAws, FaDocker, FaPython, FaHtml5, FaCss3Alt, FaJs } from 'react-icons/fa';

const TechStack = () => {
  const technologies = [
    { icon: FaReact, name: 'React', color: '#61DAFB' },
    { icon: FaNodeJs, name: 'Node.js', color: '#339933' },
    { icon: FaAws, name: 'AWS', color: '#FF9900' },
    { icon: FaDocker, name: 'Docker', color: '#2496ED' },
    { icon: FaPython, name: 'Python', color: '#3776AB' },
    { icon: FaJs, name: 'JavaScript', color: '#F7DF1E' },
    { icon: FaHtml5, name: 'HTML5', color: '#E34F26' },
    { icon: FaCss3Alt, name: 'CSS3', color: '#1572B6' },
  ];

  return (
    <section className="py-20 bg-[#030014] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-['Space_Grotesk']">
            <span className="text-white">Technologies</span> <span className="text-gradient-electric">Premium</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            La technologie des géants du web, au service des PME locales.
            Nous utilisons les outils les plus performants pour garantir votre succès.
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-8 md:gap-12">
          {technologies.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.1, y: -5 }}
              className="flex flex-col items-center gap-3 group cursor-pointer"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center text-3xl md:text-4xl transition-all group-hover:border-[var(--primary)] group-hover:shadow-[0_0_20px_rgba(112,0,255,0.3)]">
                <tech.icon style={{ color: tech.color }} />
              </div>
              <span className="text-gray-400 text-sm font-medium group-hover:text-white transition-colors">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
